// Soma de grupos — SÓ PARA EXIBIÇÃO (#80506).
//
// Quem decide acesso é o servidor (Permissions::Effective). Isto existe para a
// tela mostrar o resultado de uma escolha de grupos ANTES de salvar. As regras
// são as mesmas do backend, e é essa a razão de estarem repetidas: sem elas o
// administrador só descobriria o efeito depois de gravar.

/** Permissão UNE: quem está em dois grupos tem a soma dos dois. */
export function effectivePermissions(groups) {
  const all = new Set()
  groups.forEach(group => (group.permissions || []).forEach(id => all.add(id)))
  return [...all]
}

/**
 * Recorte AFROUXA: um valor só continua oculto se TODOS os grupos o ocultam.
 * É o "menos restritivo vence" — somar grupos nunca tira acesso. A consequência
 * precisa ficar clara para quem administra: pôr alguém num grupo amplo ANULA o
 * recorte de um grupo restritivo.
 */
export function effectiveScopes(groups) {
  if (groups.length === 0) return {}
  if (groups.length === 1) return Object.assign({}, groups[0].scopes || {})

  const result = {}
  const apps = new Set()
  groups.forEach(group => Object.keys(group.scopes || {}).forEach(app => apps.add(app)))

  apps.forEach(app => {
    const dimensions = new Set()
    groups.forEach(group => Object.keys((group.scopes || {})[app] || {}).forEach(key => dimensions.add(key)))

    const perApp = {}
    dimensions.forEach(dimension => {
      // Interseção: um grupo que não oculta nada nessa dimensão a zera.
      const sets = groups.map(group => new Set(((group.scopes || {})[app] || {})[dimension] || []))
      const common = [...sets[0]].filter(value => sets.every(set => set.has(value)))
      if (common.length) perApp[dimension] = common
    })

    if (Object.keys(perApp).length) result[app] = perApp
  })

  return result
}

/**
 * Recorte de empresa. Mesma regra: se QUALQUER grupo enxerga todas as empresas,
 * a pessoa enxerga todas; senão, a união dos CNPJs.
 */
export function effectiveCompanyScope(groups) {
  if (groups.length === 0 || groups.some(group => group.all_companies))
    return { allCompanies: true, cnpjs: [] }

  const cnpjs = new Set()
  groups.forEach(group => (group.cnpjs || []).forEach(cnpj => cnpjs.add(cnpj)))
  return { allCompanies: false, cnpjs: [...cnpjs] }
}

/** Quantos valores estão ocultos, somando produtos e dimensões. */
export function hiddenCount(scopes) {
  if (!scopes) return 0

  return Object.values(scopes).reduce(
    (total, dimensions) => total + Object.values(dimensions).reduce((sum, values) => sum + values.length, 0),
    0
  )
}
